import { colorsPalettes } from "@similarweb/styles";
import styled from "styled-components";
import { AssetsService } from "app/services/AssetsService";

export const ButtonWrapper = styled.div``;

const ReactWizardWrap = styled.div`
    position: relative;
    background-color: ${colorsPalettes.carbon["0"]};
    box-shadow: 0 3px 6px 0 rgba(14, 30, 62, 0.08);
    border-radius: 6px;

    .react-wizard {
        &-button {
            display: inline-block;
            padding: 9px 25px;
            border: none;
            color: ${colorsPalettes.carbon["0"]};
            border-radius: 3px;
            background-color: ${colorsPalettes.blue["500"]};
            box-shadow: 0 2px 4px 0 rgba(74, 134, 197, 0.3);
            outline: 0px;
            &:disabled {
                opacity: 0.6;
                cursor: default;
            }
            &:hover {
                background-color: ${colorsPalettes.blue["500"]};
            }
            &:active {
                background-color: ${colorsPalettes.blue["500"]};
            }
        }
        &-filter {
            position: relative;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin: 0 16px;
            padding-bottom: 25px;
            background: linear-gradient(
                top,
                rgba(255, 255, 255, 1) 0%,
                rgba(255, 255, 255, 1) 82%,
                rgba(255, 255, 255, 0) 100%
            );
            z-index: z("dashboard-metric-gallery-filter");
            .SearchInput-container {
                margin-bottom: 0px;
                .SearchInput {
                    border-radius: 6px;
                    box-shadow: none;
                    border: solid 1px ${colorsPalettes.carbon["50"]};
                    width: 240px;
                    height: 37px;
                    padding-left: 19px;
                    box-sizing: border-box;
                    text-indent: 22px;
                    padding-right: 40px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    color: rgba(42, 62, 82, 1);
                    margin-bottom: 0px;
                }
                .icon-search {
                    position: absolute;
                    top: 1px;
                    left: -2px;
                    font-size: 16px;
                    color: ${colorsPalettes.carbon["500"]};
                }
            }
            .LineSwitcher {
                margin-top: 9px;
            }
            &-icon {
                background: transparent url(${AssetsService.assetUrl("/images/search.svg")}) center no-repeat;
                position: absolute;
                display: block;
                width: 21px;
                height: 64px;
                top: 0;
                left: 26px;
            }
            &-input[type="text"] {
                border-radius: 6px;
                background-color: ${colorsPalettes.carbon["0"]};
                box-shadow: 0 5px 10px 0 rgba(49, 70, 93, 0.06);
                border: solid 1px ${colorsPalettes.carbon["50"]};
                width: 100%;
                height: 64px;
                padding-left: 34px;
                box-sizing: border-box;
                text-indent: 22px;
                transition:
                    background-color,
                    color 300ms;
                padding-right: 40px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                color: rgba(42, 62, 82, 1);
            }
            &--empty {
                text-align: center;
                margin-top: 150px;
                min-height: 300px;
                h4 {
                    letter-spacing: 1px;
                    text-align: center;
                    margin-bottom: 20px;
                }
                h5 {
                    letter-spacing: 1px;
                    text-align: center;
                }
            }
        }
        &-cards-container {
            display: flex;
            flex-wrap: wrap;
            padding: 0;
            margin: 0;
            justify-content: space-between;
            &-card {
                cursor: pointer;
                flex: 0 1;
                flex-basis: calc(50% - 90px);
                max-width: 43%;
                height: 178px;
                border-radius: 6px;
                background-color: ${colorsPalettes.carbon["0"]};
                box-shadow: 0 3px 6px 0 rgba(49, 70, 93, 0.06);
                border: solid 1px ${colorsPalettes.carbon["50"]};
                margin: 14px 16px;
                padding: 32px 32px 32px 24px;
                position: relative;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                button {
                    opacity: 0;
                    transition: opacity 400ms ease;
                }
                &:hover,
                &--hover {
                    box-shadow: 0 6px 12px 0 rgba(183, 207, 232, 0.2);
                    border: solid 2px rgba(74, 134, 197, 0.4);
                    margin: 13px 15px; /* because of the border of 2px, preventing jumping */
                    .react-wizard-card-image-overlay {
                        text-align: center;
                        transition: background-color 400ms ease;
                        button {
                            opacity: 1;
                            transition: opacity 400ms ease;
                        }
                    }
                }
                .react-wizard-card-text {
                    position: relative;
                    float: left;
                    max-width: 40%;
                    text-overflow: ellipsis;
                    strong {
                        width: 100%;
                        line-height: 24px;
                        letter-spacing: 0.2px;
                        color: ${colorsPalettes.carbon["500"]};
                        margin: 12px 0;
                        display: inline-block;
                    }
                    p {
                        line-height: 24px;
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-line-clamp: 5;
                        -webkit-box-orient: vertical;
                    }
                }
                .react-wizard-card-image {
                    width: 57%;
                    position: relative;
                    float: right;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    img {
                        max-height: 174px;
                    }
                }
                .react-wizard-card-image-overlay {
                    position: absolute;
                    top: 0px;
                    right: 0px;
                    max-width: 330px;
                    width: 100%;
                    height: 100%;
                    text-align: center;
                    transition: background-color 400ms ease;
                    button {
                        position: relative;
                        top: 69px;
                        margin-left: auto;
                        margin-right: auto;
                        z-index: z("dashboard-metric-gallery-filter");
                    }
                }
            }
            &-card--disabled {
                &:hover,
                &.react-wizard-cards-container-card--hover {
                    border: solid 2px rgba(65, 189, 99, 0.4);
                }
                .react-wizard-card-image-overlay {
                    button {
                        background-color: ${colorsPalettes.green["s100"]};
                        &:hover {
                            background-color: ${colorsPalettes.green["s100"]};
                        }
                        &:active {
                            background-color: ${colorsPalettes.carbon["500"]};
                        }
                    }
                }
                .react-wizard-card-text > strong:after {
                    content: "";
                    position: relative;
                    z-index: z("dashboard-metric-gallery-upgrade-icon");
                    left: 6px;
                    bottom: 1px;
                    padding: 8px;
                    background-image: url(${AssetsService.assetUrl(
                        "/images/dashboard/metric-gallery-upgrade-icon.svg",
                    )});
                    background-repeat: no-repeat;
                    background-position: center center;
                    background-size: 100%;
                }
            }
        }
    }
    .step-content {
        position: relative;
        display: inline-block;
        width: 100%;
        .input-text-default {
            width: 100%;
        }
        &-widget {
            float: left;
            width: 50%;
            margin-top: 10px;
            &-loader {
                margin: 18px 36px 0 36px;
                background-color: ${colorsPalettes.bluegrey["100"]};
                border: solid 1px ${colorsPalettes.carbon["50"]};
                min-height: 366px;
                border-radius: 3px;
                .widgetContainerTemplate {
                    border-radius: 3px;
                }
            }
            .widgetContainerTemplate {
                background-color: ${colorsPalettes.carbon["50"]};
                min-height: 366px;
                .legend .legend-item .item-icon {
                    width: 16px;
                    height: 16px;
                }
                .swWidgetCog,
                .addToDashboard {
                    display: none;
                }
            }
        }
        .autoComplete {
            padding: 18px 0 0 36px;
            margin-bottom: 262px;
        }
        .metricType {
            width: 400px;
            margin-bottom: 30px;
        }
        .filters {
            display: flex;
            justify-content: space-between;
            width: 100%;
            flex-wrap: wrap;
            .DropdownContent-container {
                margin-left: 1px;
            }
            .DropdownButton .DropdownItem-countryFlag {
                margin-right: 10px;
                position: relative;
            }
            .country {
                .DropdownButton {
                    padding-left: 15px;
                }
                .DropdownItem-countryFlag {
                    width: 18px;
                    height: 18px;
                }
            }
            .duration,
            .country,
            .dynamicFilter {
                width: 47%;
            }
            .SearchInput {
                margin-bottom: 0;
            }
        }
        .channels {
            width: 47%;
        }
        h5 {
            font-size: 14px;
            color: ${colorsPalettes.carbon["300"]};
            letter-spacing: 0.5px;
            margin-top: 21px;
        }
        h4 {
            color: ${colorsPalettes.carbon["500"]};
            margin-bottom: 20px;
        }
        .chartSwitcher {
            .Switcher {
                .icon-chart-bar {
                    font-size: 14px;
                }
                .icon-chart-line {
                    font-size: 15px;
                }
                .icon-list {
                    font-size: 10px;
                }
                .icon-chart-pie {
                    font-size: 16px;
                }
                .icon-mobile-web {
                    font-size: 21px;
                }
            }
        }
        .step-content-controls {
            width: 50%;
            float: left;
            box-sizing: border-box;
            padding: 18px 36px 0 36px;
            margin-bottom: 51px;
            border-right: 1px solid ${colorsPalettes.carbon["50"]};
            min-height: 548px;
        }
        .step-content-type {
            width: 50%;
            float: left;
            padding: 18px 36px 0 36px;
            box-sizing: border-box;
        }
        .step-content-preview {
            float: left;
            width: 50%;
            padding: 18px 36px 0 36px;
            box-sizing: border-box;
        }
    }
    .step-footer {
        background-color: ${colorsPalettes.bluegrey["100"]};
        box-shadow: inset 0 1px 0 0 ${colorsPalettes.carbon["50"]};
        text-align: right;
        display: flex;
        flex-direction: row-reverse;
        button {
            margin: 20px;
        }
    }
    .widgetWizard-autoCompleteContainer {
        &.Mobile {
            .SimpleLegend-item-icon-container img {
                width: 24px;
                height: 24px;
            }
        }
    }
    .widgetWizard-autoComplete {
        width: 100%;
        margin-bottom: 187px;
        position: relative;
        height: 44px;
        .widgetWizard-keyCount {
            position: absolute;
            right: 0px;
            top: 1px;
            letter-spacing: 0.2px;
            color: ${colorsPalettes.carbon["500"]};
            &--error {
                color: ${colorsPalettes.red["400"]};
            }
        }
    }
    .widgetWizard-tagsWrapper {
        max-width: 100%;
        flex-wrap: wrap;
        display: flex;
        .tag-wrap {
            margin: 10px 10px 0px 0px;
            .with-icon {
                i {
                    color: ${colorsPalettes.midnight["100"]};
                }
                .sw-icon-keyword {
                    font-size: 19px;
                    position: absolute;
                    left: 6px;
                    top: 7px;
                }
                .tag {
                    padding: 6px 6px 6px 30px;
                }
            }
            .tag {
                border-radius: 3px;
                background-color: ${colorsPalettes.carbon["0"]};
                border: solid 1px ${colorsPalettes.midnight["50"]};
                padding: 6px 15px;
                position: relative;
                font-size: 14px;
                font-weight: 600;
                letter-spacing: 0.3px;
                text-align: center;
                color: ${colorsPalettes.carbon["500"]};
            }
            .tag-close-button {
                cursor: pointer;
                position: absolute;
                top: -6px;
                right: -5px;
                border: 1px solid ${colorsPalettes.midnight["50"]};
                border-radius: 50%;
                background-color: ${colorsPalettes.carbon["0"]};
                background-position: center;
                padding: 0px;
                font-size: 8px;
                color: ${colorsPalettes.carbon["300"]};
                width: 14px;
                height: 14px;
                text-align: center;
                line-height: 1.8;
            }
        }
        .SimpleLegend {
            flex-wrap: wrap;
            width: 100%;
            img {
                border-radius: 3px;
            }
            .SimpleLegend-item--closable {
                margin-top: 10px;
                width: 33.33%;
                .SimpleLegend-item-text {
                    max-width: calc(100% - 70px);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }
    .swWizard-back {
        font-size: 163%;
        color: ${colorsPalettes.blue["500"]};
        border-right: 1px solid ${colorsPalettes.carbon["50"]};
        padding: 15px 22px;
        cursor: pointer;
    }
`;
ReactWizardWrap.displayName = "ReactWizardWrap";
